import React from 'react';
import SearchField,
{ SearchBoxContainer } from '@fuww/library/src/SearchField';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import messages from '../../lib/messages.mjs';

const SearchBox = (properties) => {
  const intl = useIntl();

  return (
    <SearchField
      {...properties}
      id="events-search"
      label={intl.formatMessage(messages.eventsSearchPlaceholder)}
    />
  );
};

const Search = ({ children, ...properties }) => (
  <SearchBoxContainer>
    <SearchBox
      {...properties}
    />
    {children}
  </SearchBoxContainer>
);

Search.propTypes = {
  children: PropTypes.node,
};

Search.defaultProps = {
  children: undefined,
};

export default Search;
